import { finance } from "../data";

/**
 * @param {Phaser.Scene} scene
 */
export const createCharacter = (scene) => {
  scene.anims.resumeAll(); // to resume all the anims in case we return back to the scene.
  let character;
  if (!finance.skinned) {
    character = scene.physics.add
      .sprite(-10, scene.threshold, "run0")
      .setOrigin(0, 1)
      .setDisplaySize(200 * scene.scaleX, 200 * scene.scaleX)
      .setBodySize(150)
      .setDepth(2);
    character.play({ key: "run" });
  } else {
    character = scene.physics.add
      .sprite(-10, scene.threshold, "skinnedRun0")
      .setOrigin(0, 1)
      .setDisplaySize(200 * scene.scaleX, 200 * scene.scaleX)
      .setBodySize(150)
      .setDepth(2);
    character.play({ key: "skinnedRun" });
  }
  return character;
};
